// extracted by mini-css-extract-plugin
module.exports = {"vertical":"social-share-m__vertical__2-tlX","open":"social-share-m__open__2AcWj","share":"social-share-m__share__3OJEK","floating-share":"social-share-m__floating-share__29N9t"};